import { WidgetInstance } from "mobx-store/stores/customScreens/types";
import { ValidationOptionsKeys } from "screens/addEditCustomScreen/types";
import { ValidationSchema } from "../validation.helper";

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: string) => void;
  removeFocusedWidget: () => void;
  handleMultipleChangeData: (params: {}) => void;
}

export enum horizontalWidgetType {
  STATIC="static",
  INTENAL="internal",
  EXTERNAL="external",
};

export enum ColorPalette {
  ERROR="ERROR",
  PRIMARY="PRIMARY",
  SURFACE="SURFACE",
  CONTRAST="CONTRAST",
};


export const horizontalWidgetValidation: ValidationSchema =  {
  title: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  description: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  imageURL: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  colorPalette: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  dismissButton: [],
  actionButtonTitle: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  actionButtonType: [{
          validation: [ValidationOptionsKeys.REQUIRED],    
  }],
  actionButtonExternalLink: [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'actionButtonType',
      value: horizontalWidgetType.EXTERNAL
    }
  }],
  actionButtonParams: [],
  actionButtonRedirect: [{
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'actionButtonType',
        value: horizontalWidgetType.INTENAL
      }
  }],
  actionButtonEntityId: [],
  actionButtonStaticTitle: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'actionButtonType',
        value: horizontalWidgetType.STATIC
      }
    }
  ],
  actionButtonStaticDescription: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'actionButtonType',
        value: horizontalWidgetType.STATIC
      }
    }
  ],
  subTitle: [],
  isFullButton: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
    }
  ]

}